function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-tree/~/recompose/~/@babel/runtime/helpers/inheritsLoose.js
// module id = 808
// module chunks = 0